import React from 'react';
import { loadJS } from './loadJS';

let config = {};

function setConfig(nextConfig) {
    config = {
        ...config,
        ...nextConfig,
    };
}

export const useRefJs = function (useList, func) {
    class LogProps extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                loaded: false,
                args: [],
            };
        }
        componentDidMount() {
            if (Array.isArray(useList)) {
                Promise.all(
                    useList.map(dep => {
                        let path, component;
                        if (config[dep]) {
                            path = config[dep];
                            component = dep;
                        } else if (/\.js$/.test(dep)) {
                            path = dep;
                            component = dep.substr(0, dep.length - 3);
                        } else {
                            path = dep + '.js';
                            component = dep;
                        }
                        return new Promise(resolve => {
                            loadJS(
                                path,
                                () => {
                                    let res = null;
                                    try {
                                        res = window[component].default || window[component];
                                    } catch (e) {
                                        console.log(e)
                                    }
                                    resolve(res);
                                },
                                () => {
                                    resolve(null);
                                },
                            );
                        });
                    }),
                ).then(args => {
                    this.setState({
                        loaded: true,
                        App: func(...args),
                    });
                });
            } else {
                this.setState({
                    loaded: true,
                    App: func(),
                });
            }
        }
        render() {
            let { loaded, App } = this.state;
            const { forwardedRef, ...rest } = this.props;
            if (loaded) {
                return <App {...rest} ref={forwardedRef} />;
            } else {
                return null;
            }
        }
    }
    // 注意 React.forwardRef 回调的第二个参数 “ref”。
    // 我们可以将其作为常规 prop 属性传递给 LogProps，例如 “forwardedRef”
    // 然后它就可以被挂载到被 LogProps 包裹的子组件上。

    return React.forwardRef((props, ref) => {
        return <LogProps {...props} forwardedRef={ref} />;
    });

};

useRefJs.setConfig = setConfig;
